__turbopack_context__.v({
  "app-badge-button": "Button-module-scss-module__KesjTG__app-badge-button",
  "button": "Button-module-scss-module__KesjTG__button",
});
